// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';
import { CURRENCY_RATE_PROVIDER } from '../../../constants/currencyRateProvider';

/**
 * Where rates come from. A source's pairs are its rows on the Currency rates page:
 * add a row there with empty rates and, while syncEnabled is on, core-cron fills
 * in its buy and sell rates from the provider. A manual source cannot sync — the
 * API refuses it — and its rates are typed in by hand.
 */
export default class CurrencyRateSourcesPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'publicCurrencyRateSources';
        this.Server = this.props.context.getState().server.publicCurrencyRateSources;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name'];
        this.showDatePicker = false;

        const defaultHead = [
            { id: 'name', required: true, label: 'name', alignRight: false, cell: 'Text', displayGrid: true },
            {
                id: 'provider',
                required: true,
                label: 'provider',
                alignRight: false,
                cell: 'Items',
                items: CURRENCY_RATE_PROVIDER,
                displayGrid: true
            },
            { id: 'syncEnabled', label: 'syncEnabled', alignRight: false, cell: 'Boolean', displayGrid: true },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
